<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card style="width: 500px">
      <q-toolbar>
        <q-toolbar-title> {{ $t('label.select_message') }} </q-toolbar-title>

        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>
      <q-toolbar>
        <q-btn no-caps color="primary" @click="onAdd()" :label="$t('label.message.compose_new_message')" class="full-width" />
      </q-toolbar>
      <q-card-section>
        <q-list separator dense>
          <q-item v-for="message in messages" :key="message._id" clickable>
            <q-item-section class="text-bold">
              <q-item-label class="full-width ellipsis">
                {{ message.title || '-' }}
              </q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-btn no-caps outline dense color="primary" @click="onSelect(message)" :label="$t('select')" />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
  <MessagesFormModal
    v-if="modalMessageVisible"
    :modalVisible="modalMessageVisible"
    :messageData="selectedMessage"
    @update:closeModal="onCloseModal"
    @update:onSelect="onSelect"
    @update:onCreate="onCreate"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Emit, Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { IMessage } from '@/utils/types'
import MessagesFormModal from '@/components/messages/MessagesFormModal.vue'

@Options({
  components: { MessagesFormModal },
  directives: { maska },
  emits: ['update:closeModal', 'update:onSelect', 'update:onCreate'],
})
export default class MessageSelectorModal extends Vue {
  @Prop()
  modalVisible!: boolean

  modalMessageVisible = false
  selectedMessage: IMessage = {}

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }

  get messages(): IMessage[] {
    const messages = this.$store.getters.messages
    return [...messages].reverse()
  }

  get appId() {
    return this.$route?.params?.app_id as string
  }

  @Emit('update:onSelect')
  onSelect(message: IMessage) {
    return message
  }

  @Emit('update:onCreate')
  onCreate(message: IMessage) {
    return message
  }

  onCancel() {
    this.visible = false
  }

  onAdd() {
    this.modalMessageVisible = true
    this.selectedMessage = {
      app_id: this.appId,
    }
  }

  onCloseModal() {
    this.modalMessageVisible = false
  }
}
</script>
